(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["info-side-panel"] && !Shopify.designMode) return;
  try {
    class InfoSidePanel extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('[data-drawer]');
      this.triggers = Array.from(this.querySelectorAll('[data-open]'));
      if (!this.drawer) return;

      // Portal the drawer to <body> so a clipped or transformed ancestor
      // can't trap the fixed overlay.
      this.drawer.hidden = false;
      document.body.appendChild(this.drawer);

      this.tabs = Array.from(this.drawer.querySelectorAll('.isp__tab'));
      this.bodies = Array.from(this.drawer.querySelectorAll('[data-panel]'));
      this.closers = Array.from(this.drawer.querySelectorAll('[data-close]'));

      this.triggers.forEach((t) => t.addEventListener('click', () => this.open(t.dataset.tab)));
      this.closers.forEach((c) => c.addEventListener('click', () => this.close()));
      this.tabs.forEach((t) => t.addEventListener('click', () => this.select(t.dataset.tab)));

      this._onKey = (e) => { if (e.key === 'Escape') this.close(); };
    }

    disconnectedCallback() {
      if (this.drawer && this.drawer.parentNode) this.drawer.parentNode.removeChild(this.drawer);
      document.removeEventListener('keydown', this._onKey);
    }

    open(tab) {
      if (tab) this.select(tab);
      this.drawer.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this._onKey);
      var close = this.drawer.querySelector('.isp__close');
      if (close) close.focus();
    }

    close() {
      this.drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this._onKey);
    }

    select(tab) {
      this.tabs.forEach((t) => {
        var on = t.dataset.tab === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.bodies.forEach((b) => {
        var on = b.dataset.panel === tab;
        b.classList.toggle('is-active', on);
        b.hidden = !on;
      });
    }
  }

  if (!customElements.get('info-side-panel')) {
    customElements.define('info-side-panel', InfoSidePanel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-details"] && !Shopify.designMode) return;
  try {
    class SizeDetails extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('[data-modal]');
      this.openBtn = this.querySelector('[data-open]');
      this.closeBtn = this.querySelector('[data-close]');
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      if (!this.modal || !this.openBtn) return;

      this.openBtn.addEventListener('click', () => this.open());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());

      // Click on the backdrop (the dialog element itself) closes it
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) this.close();
      });

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.tab));
      });
    }

    open() {
      if (typeof this.modal.showModal === 'function') {
        this.modal.showModal();
      } else {
        this.modal.setAttribute('open', '');
      }
    }

    close() {
      if (typeof this.modal.close === 'function') {
        this.modal.close();
      } else {
        this.modal.removeAttribute('open');
      }
    }

    select(name) {
      this.tabs.forEach((tab) => {
        var on = tab.dataset.tab === name;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        var on = panel.dataset.panel === name;
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
      });
    }
  }

  if (!customElements.get('size-details')) {
    customElements.define('size-details', SizeDetails);
  }
  } catch(e) { console.error(e); }
})();

})();
